export default {
  alquant: {
    categories: {
      partneredProducts: "Partnered Products",
      strategies: "Strategies",
      productsDev: "Products (dev)",
    },
    faq: {
      howToInvest: {
        question: "How can I invest in one of Alquant's products?",
        answer:
          'As everyone\'s financial situation and risk profile are different, we need to evaluate yours and see if there is a fit with one of our products. To do this, please use <a href="/help/contact">our contact form</a> or drop us an email at <a href="mailto:info@alquant.com">info@alquant.com</a> to start a discussion or set up a call with us, we would be glad to help you.',
      },
      moreQuestions: {
        question: "I have another question, where can I ask it?",
        answer:
          'You can always contact us using <a href="/help/contact">our contact form</a> to ask any question. You can expect a response from us in the next 1-2 business days.',
      },
      whatAlquant: {
        question: "What is Alquant?",
        answer:
          'Alquant is a Swiss asset management company specialized in risk management improving traditional asset management through quantitative finance and artificial intelligence for the benefits of its clients. We are committed to delivering superior investment results and outstanding investor experience. More information can be found on our website: <a href="https://alquant.com" target="_blank">https://alquant.com</a>.',
      },
      whatGoal: {
        question: "What is the goal of this platform?",
        answer:
          "As Alquant is committed to providing high transparency and an outstanding investor experience, we want our clients to have access to interactive charts with daily updated values rather than boring PDF documents generated once a month in order to see how our products are performing.",
      },
    },
  },
  alpinum: {
    customSections: {
      useCases: {
        title: "Use cases",
        absoluteReturnPortfolio: {
          disclaimer:
            "This is an advertising document. This document does not constitute an offer to anyone, or a solicitation by anyone, to make any investments in securities. This document is for the intended recipient only and may not be transmitted or distributed to third parties. Past performance is not a guide to future performance and may not be repeated. You should remember that the value of investments can go down as well as up and is not guaranteed. These performance data do not take account of commissions and costs incurred on the issue and redemption of units. The fund resigns from a benchmark comparison. For further information pertaining to risks, please refer to the corresponding section of the fund prospectus (as amended from time to time). Nothing contained in this document constitutes financial, legal, tax, investment or other advice, nor should any investment or any other decisions be made solely based on this document. Any investment decision should be based on the fund prospectus (incl. integrated Fund contract), the annual report and the subscription forms etc. While the information contained in this document has been obtained from sources deemed as reliable, no representation is made as to its accuracy or completeness, and it should not be relied on as such. This document must not be issued, circulated or distributed other than to “qualified investors” as defined in CISA. If you have any enquiries concerning the document contact Alpinum Investment Management AG for further information. The document is not directed and may not be provided to any person in any jurisdiction which is prohibited by law to access such information. This document and the information contained herein are addressed exclusively to “qualified investors”, who are not “US persons” as defined in Regulation S of the US Securities Act of 1933. Neither this document, nor copies thereof may be sent or brought to the United States of America nor delivered to a US person. Paying agent of the fund is UBS Switzerland AG, Bahnhofstrasse 45, CH-8001 Zurich. The fund prospectus as well as annual reports of the fund are available to qualified investors only free of charge from Alpinum Investment Management AG, Talstrasse 82, CH-8001 Zurich, Switzerland.",
          strategyName: "Alpinum Absolute Return",
          customStrategyName: "Custom Alpinum Absolute Return",
          title: "Alpinum",
          total: "Total",
          assetClasses: {
            liquidity: "Liquidity",
            fixedIncomeLongOnly: "Fixed Income Long-Only",
            equityLongOnly: "Equity Long-Only",
            equityLongShort: "Equity Long-Short",
            alternativesOpportunistics: "Alternatives - Opportunistics",
            realAssets: "Real Assets",
          },
          description: {
            interaction:
              "This is a page where you can interactively explore various versions of the Alpinum Absolute Return Portfolio.",
            firstBullet:
              "The portfolio suits investors with a relatively low tolerance for risk and market fluctuations.",
            secondBullet:
              "The portfolio focuses on capital preservation while still offering moderate capital appreciation over time.",
            thirdBullet:
              "The portfolio follows a target return strategy aiming to achieve an annualized return in the range of approximately 5.5 - 7.5% over a business cycle.",
          },
          historicalResults: {
            title: "Historical results",
            biggestDrawdowns: {
              title: (ctx) => `Biggest monthly drawdowns of ${ctx.named("benchmark")}`,
            },
            compositionPortfolio: {
              title: "Portfolio composition",
            },
            drawdowns: {
              title: "Monthly Drawdowns",
            },
            historicalPerformance: {
              title: "Historical Performance",
            },
            performanceTable: {
              title: "Performance Table",
              statistics: {
                annualizedVolatility: "Annualized standard deviation",
                maximumDrawdown: "Largest drawdown",
                ratioOfNegativeMonthlyReturns: "Percentage of down months",
                ratioOfPositiveMonthlyReturns: "Percentage of up months",
              },
            },
            portfolioPerformanceOverview: {
              title: "Overview",
            },
            totalReturn: {
              title: "Total Return",
            },
            yearlyReturns: {
              title: "Yearly Returns",
            },
          },
          metaInfo: {
            title: "Absolute Return Portfolio",
          },
          overview: {
            lastMonth: "Last Month",
            lastYear: (ctx) => `Last Year (${ctx.named("lastYear")})`,
            ytd: (ctx) => `YTD ${ctx.named("year")}`,
          },
          parameters: {
            runAnalysis: "Run analysis",
            runUseCase: "Run use case",
            benchmark: "Benchmark",
            title: "Absolute Return Composition",
          },
        },
      },
    },
  },
  bcf: {
    redirectButtonNavBarText: "Back to Home",
  },
  bonhote: {
    redirectButtonNavBarText: "Back to Home",
    categories: {
      portfolios: "Model pension portfolios",
    },
  },
  calmgard: {
    nextSubscriptionAndRedemption: {
      nextRedemption: (ctx) =>
        `<b>Redemption</b> occurring before ${ctx.named(
          "date"
        )} at 12:00 CET will be executed at the last NAV of ${ctx.named("month")}.`,
      nextSubscription: (ctx) =>
        `<b>Subscription</b> occurring before ${ctx.named(
          "date"
        )} at 12:00 CET will be executed at the last NAV of ${ctx.named("month")}.`,
      title: "Next possible Trading Dates",
    },
  },
  citeGestion: {
    categories: {
      assetAllocationProducts: "Asset Allocation Products",
      etfPortfolios: "ETF Model Portfolios",
      fundPortfolios: "Fund Model Portfolios",
      documents: "Documents",
    },
  },
  cronos: {
    redirectButtonNavBarText: "Home page Cronos",
  },
  demo: {
    customSections: {
      useCases: {
        title: "Use cases",
        alpinum: {
          strategyName: "Alpinum",
          title: "Alpinum",
          historicalResults: {
            title: "Historical results",
            biggestDrawdowns: {
              title: (ctx) => `Biggest drawdowns of ${ctx.named("benchmark")}`,
            },
            drawdowns: {
              title: "Drawdowns",
            },
          },
          metaInfo: {
            title: "Use Case - Alpinum",
          },
          parameters: {
            runButton: "Run use case",
            benchmark: "Benchmark",
            title: "Parameters",
          },
        },
      },
    },
  },
  eriya: {
    categories: {
      advisor1: "Advisor 1",
      advisor2: "Advisor 2",
      products: "Products",
    },
  },
  globalGate: {
    additionalDisplayOrderMethods: {
      ratings: "Ratings (custom)",
    },
  },
  hqam: {
    categories: {
      funds: "Funds",
      certificates: "Certificates",
      composites: "Composites",
    },
  },
  lakefield: {
    proposalTool: {
      sectionName: "Proposal tool",
      reportGenerationSubSectionName: "Report generation",
      weightOptimizationSubSectionName: "Weight optimization",
      dataIntegritySubSectionName: "Data integrity",
      historicalAssetAllocationSubSectionName: "Historical asset allocation",
      pages: {
        benchmark: "Benchmark",
        avg: "Average",
        max: "Max",
        min: "Min",
        timePeriod: (ctx) =>
          `Time period: ${ctx.named("periodStart")} to ${ctx.named("periodEnd")}`,
        netOfFees: "net of fees",
        grossOfFees: "gross of fees",
        assetClass: {
          cashAndEqui: "Cash & equivalents",
          fixedIncome: "Fixed income",
          equity: "Equity",
          altInvest: "Alternative investments",
        },
        graph: {
          range: {
            minMax: "Min-Max",
            current: "Current",
          },
          verticalBar: {
            monthRets: "Monthly Returns (%)",
            freqMonthRets: "Frequency of Monthly Returns (%)",
          },
        },
        riskClassification: {
          cons: "Conservative",
          // For convenience, keep the white space after the dash.
          modCons: "Moderately- Conservative",
          mod: "Moderate",
          // For convenience, keep the white space after the dash.
          modAgg: "Moderately- Aggressive",
          agg: "Aggressive",
        },
        strategyReport: {
          strategyName: (ctx) =>
            `Strategy name: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
          forConsiderationOf: (ctx) => `For the consideration of: ${ctx.named("recipient")}`,
          preparedBy: (ctx) => `Prepared by: ${ctx.named("author")}`,
          preparedByAndOn: (ctx) =>
            `Prepared by: ${ctx.named("author")}, ${ctx.named("createdAsOf")}`,
          preparedOn: (ctx) => `Prepared on: ${ctx.named("createdAsOf")}`,
          dataAsOf: (ctx) => `Data as of: ${ctx.named("periodEnd")}`,
        },
        tableOfContents: {
          title: "Table of Contents",
        },
        executiveSummary: {
          title: "Executive Summary",
          benchmarkDescription: "Benchmark Description",
          perfChara: {
            title: "Performance Characteristics",
            cumReturn: "Cumulative Return (%)",
            annualReturn: "Annual Return (%)",
            volatility: "Volatility (%)",
            sharpeRatio: (ctx) => `Sharpe Ratio (risk-free: ${ctx.named("annualizedRfRates")})`,
            maxDrawdown: "Maximum Draw-Down (%)",
          },
          partnersFees: {
            title: "Lakefield Partners Fees",
            managmtFees: "Management Fee (%, per annum, charged quarterly)",
            perfFee: "Performance Fee",
            propWithPerfFee: "Proportion of the Portfolio with Performance Fee (%)",
            perfFeeComp: "Performance Fee Components:",
            percentOfPortfolio: "% of Portfolio",
            perfFeePercent: "Perf. Fee (%)",
            hwm: "HWM",
            description: "Description",
            absoluteAndNoHurlde: "Absolute, no hurdle",
            relativeToBenchmarkSli: (ctx) =>
              `Relative to Benchmark (SLI TR ${ctx.named("currency")}, no hurdle`,
            perfFeeCrystalized: "Performance Fee: crystalized and charged annually",
            hwmLong: "HWM: High-Water-Mark",
          },
          portfolioChara: {
            title: "Portfolio Characteristics",
            refCurrency: "Reference Currency",
            expectedPortfolioSize: "Expected portfolio size",
            assetCoverage: "Asset Coverage",
            multiAsset: "Multi-Asset",
            assetAllocRanges: "Asset Allocation Ranges:",
            regionalCoverage: "Regional Coverage",
            globalSwiss: "Glolbal/Swiss",
            riskClass: "Risk Classification",
          },
          custodianBankInfo: {
            title: "Custodian Bank Information",
            avaialableCustodianBank: "Available Custodian Bank(s)",
            custodianFees: "Custodian Fees",
          },
        },
        portfolioComposition: {
          title: "Portfolio Composition",
          assetAlloc: "Asset Allocation",
          strategyAlloc: {
            title: "Strategy Allocation",
            coreAlloc: "Core Allocation",
            satelliteAlloc: "Satellite Allocation",
            total: "Total",
          },
          assetAllocRanges: "Asset Allocation Ranges (%)",
          histAssetAlloc: "Historical Asset Allocation (%)",
        },
        performanceAnalysis: {
          title: "Performance Analysis",
          investGrowth: "Investment Growth",
          keyPerfStats: {
            title: "Key Performance Statistics",
            currency: "Currency",
            cumReturn: "Cumulative Return (%)",
            annualReturn: "Annual Return (%)",
            volatility: "Volatility (%)",
            sharpeRatio: (ctx) => `Sharpe Ratio (risk-free: ${ctx.named("annualizedRfRates")})`,
            maxDrawdown: "Maximum Draw-Down (%)",
          },
          histYearyRets: "Historical Yearly Returns",
          histMonthRets: "Historical Monthly Returns",
        },
        riskAnalysis: {
          title: "Risk Analysis",
          drawdownAnalysis: "Drawdown Analysis",
          drawdownTable: {
            title: "Drawdown Table",
            drawdownRank: "Drawdown Rank",
            drawdown: "Drawdown (%)",
            startDate: "Start Date",
            bottomDate: "Bottom Date",
            endDate: "End Date",
          },
          riskMetrics: {
            title: "Risk Metrics",
            volatility: "Volatility (%)",
            sharpeRatio: (ctx) => `Sharpe Ratio (risk-free: ${ctx.named("annualizedRfRates")})`,
            sortinoRatio: (ctx) => `Sortino Ratio (risk-free: ${ctx.named("annualizedRfRates")})`,
            maxDrawdown: "Maximum Draw-Down (%)",
          },
          distribMonthlyRets: "Distribution of Monthly Returns",
          riskCat: "Risk Categorization",
        },
        portfolioHoldings: {
          title: "Portfolio Holdings",
          assetAlloc: "Asset Allocation",
          currencyAlloc: "Currency Allocation",
          fixedIncomSectors: "Fixed Income Sectors",
          equitySectors: "Equity Sectors",
          topHoldings: {
            title: "Top Holdings",
            name: "Name",
            isin: "ISIN",
            currency: "Currency",
            assetClass: "Asset class",
            sector: "Sector",
            region: "Region",
            weight: "Weight",
          },
        },
        glossaryOfTechTerms: {
          title: "Disclaimer",
          subTitle: "Glossary of Technical Terms",
          glossary: {
            expectedShortfall: {
              title: "Expected Shortfall",
              text: 'Also known as Conditional Value at Risk (CVaR), Expected Shortfall is a risk assessment measure that quantifies the amount of tail risk an investment portfolio has. Expected Shortfall is derived by taking a weighted average of the "extreme" losses in the tail of the distribution of possible returns, beyond a critical cut-off point, typically defined as the 95th percentile historical return. Expected Shortfall is used in portfolio optimization for effective risk management.',
            },
            hwm: {
              title: 'High-Water- Mark ("HWM")',
              text: "The high-water-mark is the highest peak in value that an investment fund or account has reached. This term is often used in the context of the asset manager compensation, which is performance-based. If the manager loses money over a period, he must get the fund above the high-water-mark before receiving a performance bonus from the assets under management (AUM).",
            },
            maxDrawdown: {
              title: "Maximum Drawdown",
              text: "The maximum drawdown (MDD) is the maximum observed loss from a peak to a through of a portfolio or strategy, before a new peak is attained. Maximum drawdown is an indicator of downside risk over a specified time period.",
            },
            semiVolatility: {
              title: "Semi-volatility",
              text: 'Also known as "Downside Deviation", semi-volatility is a measure of downside risk that focuses on returns that fall below a minimum threshold, zero return in our case. It is used in the calculation of the Sortino Ratio, a measure of risk-adjusted return. The Sortino Ratio is like the Sharpe Ratio, except that replaces the standard deviation (volatility) with downside deviation (semi-volatility).',
            },
            sharpeRatio: {
              title: "Sharpe Ratio",
              text: "The Sharpe ratio was developed by Nobel laureate Wiliam F. Sharpe and is used to help investors understand the return of an investment compared to its risk. The ratio is the average return earned in excess of the risk-free rate per unit of volatility or total risk. Volatility is a measure of the price fluctuations of an asset or portfolio. Generally, the greater the value of the Sharpe ratio, the more attractive the risk-adjusted return.",
            },
            sortinoRatio: {
              title: "Sortino Ratio",
              text: "The Sortino ratio, named after Frank A. Sortino, is a variation of the Sharpe ratio that differentiates harmful volatility from total overall volatility by using the asset's standard deviation of negative portfolio returns-downside deviation-instead of the total standard deviation of portfolio returns. The greater the value of the Sortino ratio, the more attractive the risk-adjusted return.",
            },
            volatility: {
              title: "Volatility",
              text: 'Volatility is a statistical measure of the dispersion of returns for a given security or strategy. The higher the volatility, the riskier the strategy. Volatility is measured as the annualized standard deviation of the strategy returns. In the securities markets, volatility is often associated with big swings in either direction. For example, when the stock market rises and falls more than one percent over a sustained period of time, it is called a "volatile" market.',
            },
          },
          disclaimer: {
            para1:
              "This document and the information provided are for promotional and informational purposes. The content of this document was produced by Lakefield Partners AG with the greatest of care and to the best of its knowledge and belief. However, Lakefield Partners AG provides no guarantee with regard to its content and completeness and does not accept any liability for losses which might arise from making use of this information. The information provided is for information purposes only and is for the exclusive use of the recipient. This document may not be reproduced, redistributed or republished for any purpose without the written permission of Lakefield Partners AG.",
            para2:
              "The information mentioned herein is not intended to be construed as a solicitation or an offer to buy or sell any securities, related financial instruments or to execute any other transactions. The contents of this document should not be construed as investment, legal or tax advice. The information in this document are not intended for US persons (as determined within the meaning of Regulation S under the US Securities Act of 1933, in their currently valid version), neither of those subject to a jurisdiction that prohibits access to or publication of this document (due the person's nationality, place of residence or other reasons). Access to this document is prohibited for persons who are subject to local restrictions.",
            para3:
              "Every investment involves risk, especially with regard to fluctuations in value and return. Investments in foreign currencies involve the additional risk that the foreign currency might lose value against the investor's reference currency. It should be noted that historical returns are no guarantee of future performance. Moreover, there is no guarantee that the performance of the reference index or benchmark will be reached or outperformed. Furthermore this information pays no regard to the specific or future investment objectives, financial or tax situation or particular needs of any specific recipient.",
            para4:
              "Please refer to the factsheets of their respective component strategies for explanations and clarifications related to their individual performances. The performance may be partially simulated to illustrate the characteristics of a strategy. The composition and portfolio characteristics may vary significantly during or after implementation from those shown here.",
            para5:
              "Please read the prospectus or product information for the fund and the KIID/KID carefully before making your final investment decision. All offering documents, i.e. the prospectus or placement prospectus, the Key Investor Information Document (KIID), the Key Information Document (KID), the contractual terms and conditions of the funds as well as the annual and semi-annual reports are available, if available, free of charge at Lakefield Partners AG, Seefeldstrasse 281, 8008 Zurich or at https://www.fundinfo.com.",
            para6:
              "Client information in accordance with the Financial Services Act (FIDLEG) Based on the legal requirements of the Financial Services Act (FIDLEG), the following link provides an overview of Lakefield Partners AG and its services. https://www.lakefieldpartners.com/en/regulatory-information/",
          },
        },
      },
      report: {
        backToInputs: "Go back to inputs",
        downloadReport: "Download report",
        taskFailed: (ctx) => `Task ${ctx.named("taskName")} failed: ${ctx.named("reason")}`,
      },
      reportInputs: {
        generateReport: "Generate report",
        checkDataIntegrity: "Check data integrity",
        reportName: {
          strategyReport: "Strategy Report",
          investmentProposal: "Investment Proposal",
        },
        fields: {
          general: {
            title: "General",
            portfolioName: "Portfolio name",
            portfolioNamePlaceholder: "Type to search or add custom name",
            reportName: "Report name",
            author: "Author",
            recipient: "Recipient",
            createdAsOf: "Created as of",
            currency: "Currency",
            startingValue: "Starting value",
            portfolioNameSections: {
              clientSolutions: "Client Solutions",
              pensionSolutions: "Pension Solutions",
              cornerstoneStrategies: "Cornerstone Strategies",
            },
          },
          executiveSummary: {
            title: "Executive Summary",
            availableCustodian: "Available Custodian Bank(s)",
            textSection: "Text section",
            textSectionTitle: "Title",
            textSectionContent: "Content",
          },
          composition: {
            title: "Composition",
            lakefieldProducts: "Lakefield products",
            product: "Product",
            currency: "Currency",
            availableUntil: "Available until",
            period: "Period",
            weight: "Weight (%)",
            addProduct: "Add product",
            hedgeIsSynthetic:
              "One of the component strategy is not available in the selected currency. Please get internal sign off.",
            satellites: "Satellites",
            satellite: "Satellite",
            addSatellite: "Add satellite",
            singleSatelliteWeightWarning:
              "Single satellite weight exceeds 10%. Please get internal sign off.",
            aggregatedSatelliteWeightsWarning:
              "Aggregate satellite weights exceed 30%. Please get internal sign off.",
            total: "Total",
            selectOneProduct:
              "Select at least one product in the composition to be able to select a period.",
          },
          fees: {
            title: "Fees",
            custodianFees: "Custodian Fees (in %)",
            expectedPortfolioSize: "Expected portfolio size",
            feeBasis: "Fee basis",
            feeBasisGross: "Gross",
            feeBasisNet: "Net",
            custodianFeesDefault: "All-in-Fee 0.15% p.a. + CHF 100 Ticket Fee",
            overridenFixedFees: "Overriden fixed fees (in %)",
            overridenFixedFeesCantSetWithGross:
              "You can’t apply a discount when using the gross fee basis.",
            overridenFixedFeesCantSetWithLowAum:
              "A discount requires an expected portfolio size of at least 5M.",
            overridenFixedFeesWarning:
              "A discount is being applied on the pricing. Please get internal sign off.",
            withPerfFees: "With performance fees",
          },
          benchmark: {
            title: "Benchmark",
            selection: "Selection",
            selectionStandard: "Standard",
            selectionAlternative: "Alternative",
            selectionNone: "None",
            benchmark: "Benchmark",
            currency: "Currency",
            availableUntil: "Available until",
            weight: "Weight (%)",
            addBenchmark: "Add benchmark",
            doNotAbuse:
              "Users are requested not to misuse this feature by generating benchmarks that fail to reflect a fair and accurate representation of the product's composition.",
          },
          pagesSelection: {
            title: "Pages Selection",
            page: {
              portfolioHoldingsChart: "Portfolio Holdings (charts)",
              portfolioHoldingsList: "Portfolio Holdings (list)",
            },
          },
          miscellanous: {
            title: "Miscellanous",
            numMonthlyReturns: "Number of years for historical monthly returns",
            numTopHoldings: "Number of holdings for top holdings",
            numTopHoldingsTooltip: "[WIP] Leave empty to get all holdings.",
          },
        },
      },
      weightOptimization: {
        portfoliosWeightsAllocation: "Portfolios' weights allocation",
        core: "Core",
        addProduct: "Add product",
        satellite: "Satellite",
        addSatellite: "Add satellite",
        total: "Total",
        chartsAndTables: {
          buttonText: "Generate charts and tables",
          dataLoadError:
            "An error occurred while loading the data. Please try again or contact Alquant AG if the issue persists.",
          drawdowns: "Drawdowns",
          performance: "Performance",
          period: "Period",
          periodSelectionCondition:
            "Ensure that every component with a non-zero weight in any portfolio has a selected name and currency.",
          returnToRiskSpace: "Return to risk space",
          selectedPortfolios: "Selected portfolios",
          statistics: "Statistics",
          year: "Year",
          yearlyReturns: "Yearly returns",
        },
        actionTooltip: {
          restoreDefaultPortfolio: (ctx) =>
            `Revert to the default allocation for '${ctx.named("portfolioName")}'.`,
          cantRestoreDefaultPortfolio: "The portfolio is already set to the default allocation.",
          optimizeWeight: (ctx) =>
            `Optimize weights for '${ctx.named("portfolioName")}' based on constraints and objectives.`,
          cantOptimizeWeight:
            "Optimization requires valid symbols and currencies for all items, plus at least one Core or Satellite position.",
          usePortfolioToGenerateReport: (ctx) =>
            `Generate a report using the '${ctx.named("portfolioName")}' portfolio.`,
          cantGenerateReport:
            "Report generation requires valid symbols and currencies, and a total allocation of exactly 100%.",
        },
        optimizationDialog: {
          title: "Optimization settings",
          objective: "Objective",
          period: "Optimization period",
          bounds: "Allocation bounds",
          min: "Min",
          max: "Max",
          buttonText: "Run optimization",
          optimization: {
            minVolWithTargetMinRet: {
              name: "Minimize volatility (target annual return)",
              targetTitle: "Minimum annual return",
            },
            maxRetWithTargetMaxVol: {
              name: "Maximize return (target annual volatility)",
              targetTitle: "Maximum annual volatility",
            },
            maxRetWithTargetMaxDrawdown: {
              name: "Maximize return (target drawdown)",
              targetTitle: "Maximum drawdown",
            },
            maxReturn: {
              name: "Maximize return",
            },
            maxSharpe: {
              name: "Maximize sharpe ratio",
            },
            maxSortino: {
              name: "Maximize sortino ratio",
            },
            minVol: {
              name: "Minimize volatility",
            },
            minDrawdown: {
              name: "Minimize maximum drawdown",
            },
          },
        },
        failedOptimizationDialog: {
          title: "Optimization Failed",
          text: "No solution found. The constraints (target values and allocation limits) may be too restrictive.",
        },
      },
      dataIntegrity: {
        loadingData: "Loading data ...",
        exportToExcel: "Export to Excel",
        noSymbolSelected: (ctx) => `No symbol selected for "${ctx.named("group")}".`,
        group: {
          core: "Core",
          satellite: "Satellite",
          benchmark: "Benchmark",
          cash: "Cash",
          forex: "Forex",
        },
        multiselect: {
          placeholder: "Select symbol",
          selectLabel: "Press enter to select",
          deselectLabel: "Press enter to remove",
          selectedLabel: "Selected",
          selectGroupLabel: "Press enter to select group",
          deselectGroupLabel: "Press enter to deselect group",
          limitText: (ctx) => `and ${ctx.named("count")} more`,
        },
      },
      historicalAssetAllocation: {
        title: "Historical asset allocation management",
        description:
          "To update, export the current CSV, modify the values, and import the revised file.",
        button: {
          exportCurrentAllocation: "Export current allocation",
          importNewAllocation: "Import new allocation",
        },
        export: {
          unexpectedError: {
            title: "Unexpected error",
            text: "An unexpected error occurred while processing your file. Please contact the Alquant team for assistance.",
          },
        },
        import: {
          importSuccessText: "Historical asset allocation updated, successfully.",
          importErrorText:
            "Historical asset allocation couldn't be updated. Please contact the Alquant team for assistance.",
          exceedSize: {
            title: "File too large",
            text: "The uploaded file exceeds 1&nbsp;MB. This shouldn't be possible.",
          },
          invalidData: {
            title: "Invalid data detected",
            text: "Some rows contain missing or invalid values. Make sure the <code>date</code> column uses the format <strong>YYYY-MM-DD</strong> and the other columns are valid float values.",
          },
          invalidDataSequence: {
            title: "Invalid date sequence",
            text: "Dates must be strictly increasing and unique. Please correct your file and try again.",
          },
          parseFail: {
            title: "Parsing failed",
            text: "The CSV file could not be read correctly. Please verify its format and try again. If the issue persists, contact the Alquant team.",
          },
          unexpectedError: {
            title: "Unexpected error",
            text: "An unexpected error occurred while processing your file. Please contact the Alquant team for assistance.",
          },
        },
      },
    },
  },
  mirante: {
    redirectButtonNavBarText: "Home page MFM",
  },
  msm: {
    slgOpportunitiesFund: {
      useCase: {
        strategyName: "Custom allocation with SLG",
        historicalResults: {
          title: "Historical results",
          biggestDrawdowns: {
            title: (ctx) => `Biggest drawdowns of ${ctx.named("benchmark")}`,
          },
          drawdowns: {
            title: "Drawdowns",
          },
        },
        metaInfo: {
          title: "Use Case - SLG Opportunities Fund",
        },
        notify: {
          customPortfolioUpdateErrorText: "The custom portfolio failed to be updated.",
          customPortfolioUpdateSuccessText: "The custom portfolio has been updated with success.",
        },
        parameters: {
          runButton: "Run use case",
          benchmark: "Benchmark",
          title: "Parameters",
          customPortfolio: {
            hideForNonAdminsText: "Hide for non-admins",
            title: "Custom portfolio",
            updateButton: "Update custom portfolio",
            uploadCsvText: "Upload CSV to update data",
            uploadCsvTooltip:
              "The CSV should have 1 header row and 2 columns, the first one being the dates in format YYYY-MM-DD, and the second one being the prices.",
          },
        },
      },
    },
  },
  onyxFo: {
    redirectButtonNavBarText: "Back to Home",
  },
  uti: {
    categories: {
      quantitativeStrategies: "Quantitative Strategies ÄPI®",
      thematicStrategies: "Thematic Strategies NEÜ®",
    },
  },
};
